import {ImsizeAttr} from '@diplodoc/transform/lib/plugins/imsize/const.js';

export const ImgSizeAttr = {
    Alt: ImsizeAttr.Alt,
    Src: ImsizeAttr.Src,
    Title: ImsizeAttr.Title,
    Width: ImsizeAttr.Width,
    Height: ImsizeAttr.Height,
    Loading: 'loading',
    Id: 'id',
} as const;
